import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    allTableColumnData: {},
}

export const tableSlice = createSlice({
    name: 'table',
    initialState,
    reducers: {
        setTableColumn: (state, action) => {
            state.allTableColumnData[action.payload.key] = action.payload.columns
        },
    },
})

export const { setTableColumn } = tableSlice.actions

export default tableSlice.reducer
